var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteNodeIcon = function SvgDeleteNodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F4F4F5",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M8.175 15.958 6.848 9.065h10.304l-1.327 6.893c-.097.504-.163.841-.234 1.1-.07.25-.13.374-.194.46a1.3 1.3 0 0 1-.493.407c-.096.046-.23.083-.488.103a16 16 0 0 1-1.125.022H10.71c-.514 0-.858 0-1.125-.022-.258-.02-.392-.057-.488-.103a1.3 1.3 0 0 1-.493-.407c-.063-.086-.125-.21-.194-.46a16 16 0 0 1-.234-1.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M9.7 8.25a2.3 2.3 0 1 1 4.6 0v.454H9.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M13.5 12h-3M6 8.733h12"
  })));
};
export default SvgDeleteNodeIcon;